import { AvailableExams } from "./available-exams";
import { Dates } from "./dates";
export class Session {
    constructor() {
        this.certificateSelect = $("#certificate");
        this.centerInput = $("#center");
        this.addressInput = $("#address");
        this.cityInput = $("#city");
        this.useCenterLocationInput = $("#use-center-location");
        this.useCenterCityInput = $("#use-center-city");
        this.maxQuotaInput = $("#max_quota");
        this.serviceGroupInput = $("#services");
        this.statusInput = $("#status");
        this.currencyCodeInput = $("#currency");
        this.exams = new AvailableExams();
        this.certificateSelect.on("change", () => this.onCertificateChanged());
        this.onCertificateChanged();
        this.useCenterLocationInput.on("change", () => this.onUseCenterLocationChanged());
        this.useCenterCityInput.on("change", () => this.onUseCenterCityChanged());
    }
    get dates() {
        const dates = new Dates();
        if (!dates.correct) {
            return undefined;
        }
        return dates;
    }
    get centerValue() {
        return this.centerInput.val();
    }
    get addressValue() {
        if (this.useCenterLocation) {
            return "";
        }
        return this.addressInput.val();
    }
    get cityValue() {
        if (this.useCenterLocation) {
            return "";
        }
        return this.cityInput.val();
    }
    get serviceGroup() {
        return this.serviceGroupInput.val();
    }
    get useCenterLocation() {
        return this.useCenterLocationInput.is(":checked");
    }
    get useCenterCity() {
        return this.useCenterCityInput.is(":checked");
    }
    get maxQuota() {
        const maxQuota = this.maxQuotaInput.val();
        if (!maxQuota.match(/^[0-9]*$/) === null || parseInt(maxQuota) <= 0) {
            throw new Error("El cupo máximo no es correcto. Debe ser un número entero mayor que cero.");
        }
        return parseInt(maxQuota);
    }
    get status() {
        return parseInt(this.statusInput.val());
    }
    get currencyCode() {
        return this.currencyCodeInput.val();
    }
    onCertificateChanged() {
        this.exams.showCertificateExams(this.certificateSelect.val());
    }
    onUseCenterLocationChanged() {
        if (this.useCenterLocation) {
            $("#location-inputs").addClass("hidden");
        }
        else {
            $("#location-inputs").removeClass("hidden");
        }
    }
    onUseCenterCityChanged() {
        if (this.useCenterCity) {
            $("#city-inputs").addClass("hidden");
        }
        else {
            $("#city-inputs").removeClass("hidden");
        }
    }
}
